<h2 mat-dialog-title>Add DNS Record</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    @for (control of currentControls$ | async; track control.controlName) {
      @if (control.type === 'radio') {
        <div class="radio">
          <div class="label">{{ control.label }}</div>
          <mat-radio-group aria-label="Select an option" [formControlName]="control.controlName">
            @for (option of control.options; track $index) {
              <mat-radio-button [value]="option.value">{{ option.label }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      } @else {
        <app-input-field
          [label]="control.label"
          [placeholder]="control.placeholder || ''"
          [formControlName]="control.controlName"
          [type]="control.type"
          [options]="control.options || []"
          [hint]="control.hint || ''"
          [suffixText]="control.suffixText ? hostSuffix : ''"
        ></app-input-field>
      }
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Add DNS Record</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
